import React, { FC, InputHTMLAttributes } from "react";
import { ILogin } from "../../../../utils/types";
import "./styleComponents.css";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  login: ILogin;
  handleChange(field: any, value: string): void;
}

const LoginUsernameInput: FC<InputProps> = ({
  login,
  handleChange,
  ...prop
}) => {
  return (
    <div>
      <input
        className="loginInput"
        type="text"
        placeholder="usuário"
        value={login.username}
        onChange={(e) => handleChange("username", e.target.value)}
        autoComplete="username"
        {...prop}
      />
    </div>
  );
};

export default LoginUsernameInput;
